import React, { useState } from 'react'
import Modal from '../../../../components/Modal'
import DatePickerField from '../../../../components/DatePickerField'

/**
 * Модалка выбора даты начала действия тарифов.
 * 
 * Props:
 *  - isOpen: boolean
 *  - onClose: () => void
 *  - onSave: (effectiveDate: string) => Promise<void>
 *  - saving: boolean
 */
export default function EffectiveDateModal({ isOpen, onClose, onSave, saving }) {
  const [effectiveDate, setEffectiveDate] = useState(new Date().toISOString().split('T')[0])

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Дата применения тарифов"
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', minWidth: '320px', padding: '8px 0 16px' }}>
        <p style={{ fontSize: '14px', color: 'var(--text-secondary)', lineHeight: '1.5', margin: 0 }}>
          Укажите, с какого числа вступает в силу эта тарифная сетка. Все смены до этого дня будут рассчитаны по старым тарифам, а начиная с выбранной даты — по новым.
        </p>

        <div className="input-group">
          <label style={{ fontWeight: 600, fontSize: '13px', color: 'var(--text-primary)', marginBottom: '6px', display: 'block' }}>
            Дата вступления в силу:
          </label>
          <DatePickerField
            value={effectiveDate}
            onChange={(newVal) => setEffectiveDate(newVal)}
            placeholder="Выберите дату"
          />
        </div>

        <div style={{ display: 'flex', gap: '12px', marginTop: '8px' }}>
          <button
            type="button"
            className="btn btn-ghost"
            style={{ flex: 1 }}
            onClick={onClose}
            disabled={saving}
          >
            Отмена
          </button>
          <button
            type="button"
            className="btn btn-primary"
            style={{ flex: 2, background: 'linear-gradient(135deg, var(--wb-primary), #9333ea)', color: 'white' }}
            onClick={async () => {
              onClose()
              await onSave(effectiveDate)
            }}
            disabled={saving || !effectiveDate}
          >
            Применить с этой даты
          </button>
        </div>
      </div>
    </Modal>
  )
}
